import { render } from "./ShareHolderList.vue?vue&type=template&id=8c602502"
import script from "./ShareHolderList.vue?vue&type=script&lang=js"
export * from "./ShareHolderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__